import { Turbo } from '@hotwired/turbo-rails'
import './controllers'
import mermaid from 'mermaid'
import 'chartkick/chart.js'

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}

// Re-initialize Chartkick charts after Turbo Frame loads
// Turbo does not execute inline scripts when replacing frame content,
// so we need to manually execute them to initialize charts
document.addEventListener('turbo:frame-load', (event) => {
  const frame = event.target
  const scripts = frame.querySelectorAll('script')
  scripts.forEach((script) => {
    if (script.textContent && script.textContent.includes('Chartkick')) {
      try {
        const newScript = document.createElement('script')
        newScript.textContent = script.textContent
        script.parentNode.replaceChild(newScript, script)
      } catch (_e) {
        // ignore
      }
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  mermaid.initialize({
    startOnLoad: true,
    theme: 'base' // or "default", "dark", etc.
  })
})

import 'trix/dist/trix.css'
import '../assets/stylesheets/actiontext.css'
import 'trix'
import '@rails/actiontext'
import './trix_init'
